import React, { useEffect, useState } from 'react';
import { columnsData, COUPON_STATUS_REVERSE, initialValues } from './base';

import style from './style.module.scss';
import { Table, Tabs } from 'antd';
import DiscountCouponsForm from './DiscountCouponsForm';
import CouponDetailsModal from './CouponDetailsModal';
import DeactivateCouponModal from './DeactivateCouponModal';
import {
  createNewDiscountCoupon,
  deactivateCoupon,
  getDiscountCouponData,
} from 'store/actions/DiscountCouponActions';
import { connect } from 'react-redux';

const DiscountCoupons = ({
  getTableData,
  tableData,
  inactiveTableData,
  deactivateCoupon,
  createNewDiscountCoupon,
}) => {
  const [formData, setFormData] = useState({ ...initialValues });
  const [isUpdate, setIsUpdate] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [page, setPage] = useState(1);
  const [disabledPage, setDisabledPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeactivateModalOpen, setDeactivateModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedDeactivateRow, setSelectedDeactivateRow] = useState(null);
  const [filter, setFilter] = useState(COUPON_STATUS_REVERSE.ACTIVE);

  const reloader = () => {
    setLoader(!loader);
  };

  useEffect(() => {
    let params = {
      page: filter === COUPON_STATUS_REVERSE.ACTIVE ? page : disabledPage,
      filter: filter,
    };

    getTableData(params);
  }, [page, disabledPage, loader, filter]);

  const handleMenuClick = (key, record) => {
    if (Number(key) === 1) {
      setSelectedRow(record);
      setIsModalOpen(true);
    }

    if (Number(key) === 2) {
      setSelectedDeactivateRow(record);
      setDeactivateModalOpen(true);
    }
  };

  const onTabChange = (key) => {
    setFilter(Number(key));
  };

  return (
    <div className={style['page']}>
      <div className={style['head']}>
        <div className={style['headline']}>Coupon Management</div>
        <button
          className={`${style['btn']}`}
          onClick={() => {
            setFormData({ ...initialValues });
            setIsUpdate(false);
            setIsFormVisible(true);
          }}>
          Add New Coupon
        </button>
      </div>
      <Tabs defaultActiveKey="10" onChange={onTabChange}>
        <Tabs.TabPane tab={'Live Coupons'} key="10">
          <div className={style['relative']}>
            <Table
              className={style['table-class']}
              columns={columnsData(handleMenuClick)}
              dataSource={tableData?.data}
              pagination={{
                position: ['topRight'],
                defaultPageSize: 10,
                total: tableData?.total,
                size: 'small',
                showSizeChanger: false,

                onChange: (page) => {
                  setPage(Number(page));
                },
              }}
              scroll={{
                ax: 2000,
              }}
            />
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Inactive Coupons" key="20">
          <div className={style['relative']}>
            <Table
              className={style['table-class']}
              columns={columnsData(handleMenuClick)}
              dataSource={inactiveTableData?.data}
              pagination={{
                position: ['topRight'],
                defaultPageSize: 10,
                total: inactiveTableData?.total,
                size: 'small',
                showSizeChanger: false,
                onChange: (disabledPage) => {
                  setDisabledPage(Number(disabledPage));
                },
              }}
              scroll={{
                ax: 2000,
              }}
            />
          </div>
        </Tabs.TabPane>
      </Tabs>
      <div className={style['drawer-box']}>
        <DiscountCouponsForm
          isUpdate={isUpdate}
          initialFormData={formData}
          visible={isFormVisible}
          onClose={() => {
            setIsFormVisible(false);
          }}
          reload={reloader}
          createNewDiscountCoupon={createNewDiscountCoupon}
        />
      </div>
      <CouponDetailsModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        selectedRow={selectedRow}
      />
      <DeactivateCouponModal
        isModalOpen={isDeactivateModalOpen}
        setIsModalOpen={setDeactivateModalOpen}
        deactivateCoupon={() => deactivateCoupon(selectedDeactivateRow?.id)}
        reload={reloader}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  tableData: state.coupons.tableData,
  inactiveTableData: state.coupons.inactiveTableData,
});

const mapDispatchToProps = (dispatch) => ({
  getTableData: (data) => dispatch(getDiscountCouponData(data)),
  deactivateCoupon: (id) => dispatch(deactivateCoupon(id)),
  createNewDiscountCoupon: (data) => dispatch(createNewDiscountCoupon(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DiscountCoupons);
